module.exports = __webpack_public_path__ + "static/media/ch2.2d65ee9d.jpg";